import type { Dispatch, SetStateAction } from "react";
import React, { createContext, useContext, useMemo, useState } from "react";

import type { WithChildren } from "../../_metronic/helpers";

export interface LocationContextProps {
  prevLocation: string | null;
  setPrevLocation: Dispatch<SetStateAction<string | null>>;
}

const initLocationContextPropsState = {
  prevLocation: null,
  setPrevLocation: () => {},
};

const LocationContext = createContext<LocationContextProps>(
  initLocationContextPropsState,
);

export const useLocationContext = () => {
  return useContext(LocationContext);
};

export const LocationProvider: React.FC<WithChildren> = ({ children }) => {
  const [prevLocation, setPrevLocation] = useState<string | null>(null);

  const value = useMemo(() => {
    return {
      prevLocation,
      setPrevLocation,
    };
  }, [prevLocation, setPrevLocation]);

  return (
    <LocationContext.Provider value={value}>
      {children}
    </LocationContext.Provider>
  );
};
